<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Employees</h3>
        <p>Optional Search Criteria:</p>
        <form [formGroup]="viewEmployeesForm">
            <div class="field-container">
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="lastName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="firstName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Employee ID</mat-label>
                    <input matInput #input maxlength="10" formControlName="employeeId" />
                </mat-form-field>
            </div>
        </form>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="listEmployees()">Search</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resetSearch()">Reset Search</button>
            @if (userHasRole("employee-editor")) {
            <button mat-flat-button (click)="addEmployee()">Add Employee</button>
            }
        </section>

        <p class="text-aerostar-orange">{{message}}</p>

        @if (employeeCount > 0) {
        <p>Click on row to expand for additional information.</p>
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="first-name {{getAltCssClass('first-name')}}">First Name</span>
                    <span class="last-name {{getAltCssClass('last-name')}}">Last Name</span>
                    <span class="country {{getAltCssClass('country')}}">Country<mat-icon class="tool-tip-size"
                            matTooltip="Hover over Country code for full name.">information</mat-icon></span>
                    <span class="email {{getAltCssClass('email')}}">email</span>
                    <span class="phone {{getAltCssClass('phone')}}">Phone</span>
                    @if (userHasRole("employee-editor")) {
                    <span class="actions {{getAltCssClass('actions')}}">Actions</span>
                    }
                    <span class="icon {{getAltCssClass('icon')}}"></span>
                </section>
                <mat-expansion-panel hideToggle *ngFor="let employee of employees">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="first-name {{getAltCssClass('first-name')}}">{{employee.first_name}}</span>
                        <span class="last-name {{getAltCssClass('last-name')}}">{{employee.last_name}}</span>
                        <span class="country {{getAltCssClass('country')}}"
                            matTooltip="{{employee.country.en_short_name}}"
                            [matTooltipPosition]="toolTipRight.value!">{{employee.country_code}}</span>
                        <span class="email {{getAltCssClass('email')}}">{{employee.email}}</span>
                        <span class="phone {{getAltCssClass('phone')}}">{{employee.phone}}</span>
                        @if (userHasRole("employee-editor")) {
                        <span class="actions {{getAltCssClass('actions')}}">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <!-- The following "if" is only relevant when the user is
                                             an employee. If the user is a dealer or dealer rep
                                             then only employees associated with the dealer are
                                             returned from the backend. Additionally, backend security
                                             controls ensure that any update to a employee is limited
                                             to the update being made only by the associated dealer.
                                        -->
                                    @if (employee.status == "A") {
                                    <button mat-menu-item (click)="updateEmployee(employee.id)">
                                        <span>Update Employee</span>
                                    </button>
                                    }
                                    @if (userHasRole("employee-admin")) {
                                    @if (employee.status == "A") {
                                    <button mat-menu-item (click)="inactivateEmployee(employee.id)">
                                        <span>Inactivate Employee</span>
                                    </button>
                                    } @else {
                                    <button mat-menu-item (click)="reactivateEmployee(employee.id)">
                                        <span>Reactivate Employee</span>
                                    </button>
                                    }
                                    }
                                    @if (isNonProd) {
                                    <button mat-menu-item>
                                        <span (click)="deleteEmployee(employee.id)">Delete Employee<br><sup>(Limited to
                                                Non-Prod Env)</sup></span>
                                    </button>
                                    }
                                </mat-menu>
                            </ng-container>
                        </span>
                        }
                        <span class="icon {{getAltCssClass('icon')}}">@if (employee.status == "I") {<img
                                src="person-inactivated-icon.svg">}</span>
                    </mat-expansion-panel-header>
                    <div>
                        <hr>
                        <div class="employee-id">
                            <b>Employee ID:</b>&nbsp;&nbsp;{{employee.id}}
                        </div>
                        <div class="address-title">
                            <b>Address:</b>
                        </div>
                        <div class="address-info">
                            {{employee.address_line_1}}
                            <br>{{employee.address_line_2}}
                            <br>{{employee.address_line_3}}
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="employeeCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (employeeCount == 0) {
        <p>No Employees found</p>
        }
    </section>
</section>